<template>
  <div
    v-if="criteria.length"
    data-qa="patient_profile_critera_list"
  >
    <div
      v-for="(criterion, index) in criteriaTrust"
      :key="criterion"
      :class="{ 'mt-3': index !== 0 }"
      class="d-flex align-center"
    >
      <div class="ui-icon-fz-medium mr-3 success--text ui-icon-check-circle" />
      <div
        class="text-body-1"
        data-qa="patient_profile_criterion"
      >
        {{ criterion }}
      </div>
    </div>
    <div
      v-if="criteriaWithoutTrust.length > 0 && criteriaTrust.length > 0"
      class="mb-6"
    />
    <div
      v-for="(criterion, index) in criteriaWithoutTrust"
      :key="criterion"
      :class="{ 'mt-3': index !== 0 }"
      class="d-flex align-center"
    >
      <div class="ui-icon-fz-medium mr-3 warning--text ui-icon-circle-warning" />
      <div
        class="text-body-1"
        data-qa="patient_profile_criterion"
      >
        {{ criterion }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  criteria: Array<{
    can_trust: boolean
    title: string
  }>
}>()

const criteriaTrust = computed(() => (props.criteria || [])
  .filter(criteria => criteria.can_trust)
  .map(({ title }) => title))
const criteriaWithoutTrust = computed(() => (props.criteria || [])
  .filter(criteria => !criteria.can_trust)
  .map(({ title }) => title))
</script>
